export const API_BASE_URL = '/competitive/api';

export const API_ENDPOINTS = {
    GET_PRIZES: `${API_BASE_URL}/get-prizes`,
    GET_CONSENT_INTERVIEW: `${API_BASE_URL}/get-consent-interview`,
    GET_PROFILE: `${API_BASE_URL}/get-profile`,
    GET_INTERVIEW: `${API_BASE_URL}/get-interview`,
    UPDATE_PROFILE: `${API_BASE_URL}/update-profile`,
    GET_ACCOUNT_STATUS: `${API_BASE_URL}/get-account-status`,
    GET_RETAKE_AVAILABLE: `${API_BASE_URL}/get-retake-available`,
    GET_TAX_DOCUMENTS: `${API_BASE_URL}/get-tax-documents`,
    DOWNLOAD_TAX_PROFILE: `${API_BASE_URL}/download-tax-profile`,
    UPDATE_GUARDIAN_INFO: `${API_BASE_URL}/update-guardian-info`,
    GET_GUARDIAN_INFO: `${API_BASE_URL}/get-guardian-info`,
    TRACE_TAKE_INTERVIEW: `${API_BASE_URL}/trace-take-interview`,
    CONFIRM_AGE: `${API_BASE_URL}/confirm-age`,
    UPDATE_PAYOUT: `${API_BASE_URL}/payout-save`,
    GET_PAYOUT: `${API_BASE_URL}/payout-get`,
    CHECK_EMAIL_EXISTED: `${API_BASE_URL}/email-existed`
};
